import axiosInstance from "../api/axios";

export const getFaqs = async () => {
    const res = await axiosInstance.get(`/api/admin/list-faq`);
    return res.data;
};

export const getSponsors = async () => {
    const res = await axiosInstance.get(`/api/admin/list-sponsor`);
    return res.data;
};

export const getResources = async () => {
    const res = await axiosInstance.get(`/api/admin/list-resource`);
    return res.data;
};

export const changePassword = async (payload) => {
    const res = await axiosInstance.post(`/api/user/change-password`, payload)
    return res.data
}

export const getBudget = async () => {
    const res = await axiosInstance.get(`/api/user/get-budget`)
    return res.data
}

export const sendHelpRequest = async (payload) => {
    const res = await axiosInstance.post(`/api/support/help-support`, payload)
    return res.data
}